import { Component, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AttachmentFile } from '#models';
import { FileType } from '#enums';

@Component({
  selector: 'app-attachment-list-item',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './attachment-list-item.component.html',
  styleUrl: './attachment-list-item.component.scss',
})
export class AttachmentListItemComponent {
  item = input.required<AttachmentFile>();

  canDelete = input(true);
  canDownload = input(true);

  expandItem = output<AttachmentFile>();
  downloadItem = output<AttachmentFile>();
  deleteItem = output<AttachmentFile>();

  // Expose enum to template for the @switch
  FileType = FileType;

  // True once the image URL has failed to load, so we fall back to the placeholder icon
  private _imageErrored = signal(false);

  hasPreview(): boolean {
    const item = this.item();
    return !!(item.thumbnailURL || item.imageURL) && !this._imageErrored();
  }

  onImageError() {
    this._imageErrored.set(true);
  }

  onExpand() {
    this.expandItem.emit(this.item());
  }

  onDownload() {
    this.downloadItem.emit(this.item());
  }

  onDelete() {
    this.deleteItem.emit(this.item());
  }
}
